import { useState } from "react";
import { Link } from "react-router-dom";
import api, { formatApiError } from "@/lib/api";
import { Field } from "@/pages/Login";
import { toast } from "sonner";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true); setError("");
    try {
      const { data } = await api.post("/auth/forgot-password", { email });
      // Fase 8 — nunca exibimos token. Resposta anti-enumeração.
      setSent(true);
      toast.success(data?.message || "Se existir uma conta associada, enviaremos as instruções.");
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-[80vh] flex items-center justify-center px-4 py-10">
      <div className="w-full max-w-md card-soft p-8">
        <div className="text-center">
          <div className="text-4xl">🔑</div>
          <h1 className="mt-2 text-2xl font-extrabold text-[#243B53]">Recuperar senha</h1>
          <p className="text-sm text-[#243B53]/70">
            Informe o e-mail da sua conta. Enviaremos um link seguro para redefinir sua senha.
          </p>
        </div>

        {!sent ? (
          <form onSubmit={onSubmit} className="mt-6 space-y-4">
            <Field label="E-mail" type="email" value={email} onChange={setEmail} testid="forgot-email-input" />
            {error && <div data-testid="forgot-error" className="text-sm text-red-600 font-bold">{error}</div>}
            <button data-testid="forgot-submit-btn" disabled={loading} className="btn-primary w-full">
              {loading ? "Enviando…" : "Enviar link por e-mail"}
            </button>
          </form>
        ) : (
          <div className="mt-6 card-soft p-4 bg-[#FFF9ED] text-sm text-[#243B53]" data-testid="forgot-confirm">
            <p>
              Se existir uma conta associada a este e-mail, enviaremos as instruções
              para redefinir sua senha nos próximos minutos.
            </p>
            <p className="mt-3 text-xs text-[#243B53]/60">
              Não recebeu? Verifique a pasta de spam. O link expira em 1 hora.
            </p>
          </div>
        )}

        <div className="mt-4 text-sm text-center">
          <Link data-testid="forgot-back-login" to="/login" className="text-[#5DADE2] font-bold">Voltar ao login</Link>
        </div>
      </div>
    </div>
  );
}
